import { Message } from "./messageBase";
import { getMsgState, getMessageStateByName } from "./messageState";
export let msgSubscribers = [];
export let pendingMessages = [];
export function getMessageSubscribers(subject) {
    let subs = msgSubscribers.filter(s => s.subject === subject);
    return subs;
}
export function resolveAbstractMessages(cTor) {
    let abstr = msgSubscribers
        .filter(m => m instanceof AbstractSubscriber && m.subjClassName === cTor.name && m.resolved == false);
    for (let a of abstr) {
        a.subject = cTor;
        a.resolved = true;
    }
}
export function subscribeAbstract(subjectClassName, handler, ctx) {
    if (!subjectClassName)
        throw Error("Need subjects!!!");
    let x = new AbstractSubscriber(subjectClassName, handler, ctx);
    let handlePending = (handler) => {
        let pend = pendingMessages.filter(m => m.type.name === subjectClassName);
        if (pend.length > 0) {
            x.subject = pend[0].type;
            x.resolved = true;
            for (let p of pend) {
                p.addHandledCallback(() => { handler.handle(p.subject); });
            }
        }
    };
    msgSubscribers.push(x);
    handlePending(x);
    return x;
}
export function subscribe(subject, handler, ctx) {
    if (!subject)
        throw Error("Need subjects!!!");
    let handlePending = (s, handler) => {
        let pend = pendingMessages.filter(m => m.type == s);
        if (pend.length > 0) {
            for (let p of pend) {
                p.addHandledCallback(() => { handler.handle(p.subject); });
            }
        }
    };
    let x = new MessageSubscriber(subject, handler, ctx, false);
    msgSubscribers.push(x);
    handlePending(subject, x);
    return x;
}
export function disposeSubscriber(subs) {
    let ind = msgSubscribers.indexOf(subs);
    if (ind > -1)
        msgSubscribers.splice(ind, 1);
}
export function disposeContext(ctx) {
    if (ctx == null)
        return;
    let toDispose = msgSubscribers.filter(s => s.handlerCtx === ctx);
    for (let s of toDispose) {
        let ind = msgSubscribers.indexOf(s);
        msgSubscribers.splice(ind, 1);
    }
}
export class MessageSubscriber {
    constructor(subject, handler, handlerCtx, handleChildren = false) {
        this.subject = subject;
        this.handlerCtx = handlerCtx;
        if (this.handlerCtx)
            this.handler = handler.bind(this.handlerCtx);
        else
            this.handler = handler;
        this.handleChildren = handleChildren;
    }
    get hasPendingMessage() {
        return pendingMessages.some(p => p.type == this.subject);
    }
    async handle(subj) {
        try {
            await this.handler(subj);
        }
        catch (ex) {
            console.groupCollapsed(`%cError in message handler: ${this.handler.name.replace('bound ', '')}`, "color: #df6d6d; font-weight: bold; background-color: #290000;");
            console.log(this);
            console.log(subj);
            console.error(ex);
            console.groupEnd();
        }
    }
    dispose() {
        disposeSubscriber(this);
    }
    sendLastState() {
        if (this.hasPendingMessage)
            return;
        let lastState = getMsgState(this.subject);
        this.handle(lastState);
        return this;
    }
}
class AbstractMessage extends Message {
}
export class AbstractSubscriber extends MessageSubscriber {
    constructor(msgClassName, handler, handlerCtx) {
        super(AbstractMessage, handler, handlerCtx);
        this.isAbstract = true;
        this.resolved = false;
        this.subjClassName = msgClassName;
    }
    sendLastState() {
        if (this.hasPendingMessage)
            return;
        let lastState = getMessageStateByName(this.subjClassName);
        this.handle(lastState);
        return this;
    }
}
export class PendingMessage {
    constructor(s) {
        this.isClearing = false;
        this.subject = s;
        this.__handledCallbacks = [];
        this.type = s.constructor;
        this.subscribers = getMessageSubscribers(this.type);
    }
    addHandledCallback(cb) {
        this.__handledCallbacks.push(cb);
    }
    handledCallback() {
        for (let cb of this.__handledCallbacks) {
            cb();
        }
    }
}
